(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('RowType', RowType);

    RowType.$inject = ['$resource', 'DateUtils'];

    function RowType ($resource, DateUtils) {
        var resourceUrl =  'api/row-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('RowTypeSearch', ['$rootScope','$http',function($rootScope,$http){

       var service ={};
	   service.getrowtypebyname = function (data,callback){
		$http.get('api/row-types-details/'+data).then(function(response){
    	    callback(response.data);
    	});
	};
	
	return service;
    }]);
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('RowTypeSearch', RowTypeSearch);

    RowTypeSearch.$inject = ['$resource'];

    function RowTypeSearch ($resource) {
        var service = $resource('/api/row-types/searchvalue/:userId',{userId:'@id'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllCustomRowTypeAttribute', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/all-custom-row-type-attributes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();